import { getBaseRole } from '@/helpers/customRoles';
import store from "@store/redux.store";

export const getLinkToMeeting = ({report}) => {
        const storeData = store.getState();
        const isOffline = report?.isOffline == 1 || report?.is_offline == 1;
        if(isOffline && storeData?.settings?.isRemoveLinksToOfflineClasses == '1'){
            return '';
        }

        const isChildOrParent = getBaseRole(storeData?.profile?.profile?.role) === 'children' || getBaseRole(storeData?.profile?.profile?.role) === 'parent';
        if (isChildOrParent && report?.group_payment_required) {
            return '';
        }
        const isBigBlueButtonLesson = storeData?.settings?.bigBlueButtonIntegrationEnabled == '1' && (
            storeData?.settings?.bigBlueButtonIntegrationUseInLessons == '1' ||
            (report?.lessonInBigBlueButton == 1 && storeData?.settings?.bigBlueButtonIntegrationCanBeUsedInSeparateLessons == '1')
        );
        if(isChildOrParent && isBigBlueButtonLesson) {
            return report?.link_to_meeting_for_children;
        }
        if(isChildOrParent && storeData?.settings?.isSeparateLinksForStudentsAndTeachers == '1') {
            return report?.link_to_meeting_for_children || report?.link_to_meeting;
        }
        return report?.link_to_meeting;
}
